import styled from 'styled-components'
import { WidthProps, width } from 'styled-system'

export const Popper = styled.div<WidthProps>`
  border-radius: 2px;
  max-width: 400px;
  background-color: ${({ theme }) => theme.colors.label};
  padding: ${({ theme }) => theme.space.S12};
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.textCondensedFont};
  font-size: ${({ theme }) => theme.fonts.fontSize12};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  white-space: normal;
  z-index: 10000;

  ${width}
`

export const Arrow = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;

  &[data-placement^='bottom'] {
    &::before {
      border-width: 0 6px 6px 6px;
      border-color: transparent transparent ${({ theme }) => theme.colors.label} transparent;
    }
  }
  &[data-placement^='top'] {
    &::before {
      border-width: 6px 6px 0 6px;
      border-color: ${({ theme }) => theme.colors.label} transparent transparent transparent;
    }
  }
  &[data-placement^='right'] {
    &::before {
      border-width: 6px 6px 6px 0;
      border-color: transparent ${({ theme }) => theme.colors.label} transparent transparent;
    }
  }
  &[data-placement^='left'] {
    &::before {
      border-width: 6px 0 6px 6px;
      border-color: transparent transparent transparent ${({ theme }) => theme.colors.label};
    }
  }
  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }
`
